export interface CommissionsByClientReport {
  login: number;
  partnership: string;
  partneshipType: string;
  clientName: string;
  scheme: string;
  schemeType: string;
  rebateLocal: number;
  totalRebate: number;
  payment: number;
  profit: number;
  lots?: number;
  paidCashback: number;
}

export interface CommissionsByClientTotals {
  rebateTotal: number;
  rebateTotalPercentage: number;
  paymentTotal: number;
  paymentTotalPercentage: number;
  profitTotal: number;
  profitTotalPercentage: number;
  lotsTotal: number;
  lotsTotalPercentage: number;
}

export interface CommissionsByClientModel {
  items: CommissionsByClientReport[];
  total: CommissionsByClientTotals;
}

// export const reportEnColumnsRequestId = ['partnership', 'client name', 'login', 'rebate local', 'total rebates', 'payment', 'profit', 'paid cashback', 'partnership type', 'scheme', 'scheme type'];

export const enColumnsForEmail = ['partnership', 'rebate local', 'total rebates', 'payment', 'profit', 'total lots', 'partnership type', 'scheme', 'scheme type', 'sub-ib commission'];
